export default __webpack_public_path__ + "static/media/mena15.89476ed6.jpg";